<template> 
    <div>

        <div class="flex w-full justify-center">

            <div class="me-2">

                <label>class name: </label>
            </div>

            <div>

                <label>{{ mySession.class.name }}</label>
            </div>
        </div>
    </div>
</template>

<script>
 
    export default {

        props:{

            mySession:{

                type: Object
            }
        },

        mounted(){

            // console.log(`my Session: ${JSON.stringify(this.mySession)}`);
        }
     }
</script>

<style>

</style>
